module.exports = __webpack_public_path__ + "img/maintance.4da8b29a.png";